import React, { useEffect, useState, useMemo } from 'react'
import cn from 'classnames'
import { useStore } from '@/hooks/storeHooks'
import { Icon } from '@/components'
import st from './index.scss'
import {
  delLawsContent,
  delLawsList,
  getLawContentFromCache,
  getLawsListFromCache, isUseCache,
  set_LAWS_Content,
  set_LAWS_LIST_V2
} from '@/components/LawBook/provision'
import { SEARCH_ICON } from './constants'
import { set } from 'lodash'
import NewTopScorebox from '@/page/question_group/AnswerAnalysis/components/NewTopScorebox'

// 文件夹样式
function Folder({
    children,
    isSelected,
    isOpen,
    isFirst,
    isLast,
    onLeftClick,
    onRightClick,
    onRightDoubleClick,
    setStyle,
    ...props
}) {
    let open_class_name = st['folder-open']
    let no_open_class_name = st['folder-no-open']

    if (isFirst) {
        open_class_name = st['folder-open-first']
        no_open_class_name = st['folder-no-open-first']
    }

    if (isLast) {
        open_class_name = st['folder-open-last']
        no_open_class_name = st['folder-no-open-last']
    }

    return (
        <div
            {...props}
            className={cn(st['folder'], {
                [st['folder-selected']]: isSelected
            })}
            onClick={onRightClick}
            onDoubleClick={onRightDoubleClick}
        >
            <div
                className={cn(
                    st['pre-icon'],
                    isOpen ? open_class_name : no_open_class_name
                )}
                onClick={(e) => {
                    e.stopPropagation()
                    setStyle(false)
                    return onLeftClick()
                }}
            ></div>
            {/* 文件夹图标 */}
            {/* <div
                className={st['pre-icon']}
                onClick={() => setStyle(false)}
                style={{
                    backgroundPosition: isOpen ? '-110px -15px' : '-110px 0'
                }}
            ></div> */}
            {children}
        </div>
    )
}

// 文件样式
function File({ children, isSelected, isFirst, isLast, setStyle, ...props }) {
    let class_name = st['file']

    if (isFirst) {
        class_name = st['file-first']
    }

    if (isLast) {
        class_name = st['file-last']
    }

    return (
        <div {...props} className={st['file']}>
            <div className={cn(st['pre-icon'], class_name) } onClick={() => setStyle(false)}></div>
            <div
                className={cn({
                    [st['file-selected']]: isSelected
                })}
            >
                <div
                    className={st['pre-icon']}
                    onClick={() => setStyle(false)}
                    style={{
                        backgroundPosition: '-109px -31px'
                    }}
                ></div>
                {children}
            </div>
        </div>
    )
}

// 列表样式
function List({
    data,
    className,
    selectId,
    onFolderLeftClick,
    onFolderRightClick,
    onFolderRightDoubleClick,
    onFileClick,
    deep = 1,
    setStyle,
    ...props
}) {
    return (
        <div {...props} className={cn(st['list'], className)}>
            {data.map((item, idx) => {
                const dom = []
                const return_data = {
                    data: item,
                    deep
                }
                if (item.children && item.children.length > 0) {
                    dom.push(
                        <Folder
                            key={idx}
                            setStyle={setStyle}
                            title={item.title}
                            id={`${st['list']}_${item.id}`}
                            isSelected={item.id == selectId}
                            isFirst={idx === 0 && deep === 1}
                            isLast={idx === data.length - 1}
                            isOpen={!!item.is_open}
                            onLeftClick={() => onFolderLeftClick(return_data)}
                            onRightClick={() => onFolderRightClick(return_data)}
                            onRightDoubleClick={() =>
                                onFolderRightDoubleClick(return_data)
                            }
                        >
                            {item.title}
                        </Folder>
                    )
                } else {
                    dom.push(
                        <File
                            key={idx}
                            setStyle={setStyle}
                            title={item.title}
                            id={`${st['list']}_${item.id}`}
                            isSelected={item.id == selectId}
                            isFirst={idx === 0 && deep === 1}
                            isLast={idx === data.length - 1}
                            onClick={() => onFileClick(return_data)}
                        >
                            {item.title}
                        </File>
                    )
                }

                if (item.is_open) {
                    dom.push(
                        <div
                            className={st['list-children']}
                            key={`${idx}_children`}
                            onClick={() => setStyle(false)}
                        >
                            <List
                                setStyle={setStyle}
                                title={item.title}
                                data={item.children}
                                selectId={selectId}
                                onFolderLeftClick={onFolderLeftClick}
                                onFolderRightClick={onFolderRightClick}
                                onFolderRightDoubleClick={
                                    onFolderRightDoubleClick
                                }
                                onFileClick={onFileClick}
                                deep={deep + 1}
                            />
                        </div>
                    )
                }

                return dom
            })}
        </div>
    )
}

export default function Fatiao({ closeFt, onSize, setRndObj, setIsXiaoshi, ...props }) {
    const { user, api } = useStore()
    const [select_id, setSelectId] = useState()
    const [keyword, setKeyWord] = useState('')
    const [law, setLaw] = useState([])
    const [tripe, setTripe] = useState()
    const [loading, setLoading] = useState(false)
    const [search_res, setSearchRes] = useState([])
    const [search_res_idx, setSearchResIdx] = useState(0)
    const [hide_left, setHideLeft] = useState(false)
    const [is_quanping, setIsQuanping] = useState(false)
    const [promise_map, setPromiseMap] = useState(new Map())
    const [style, setStyle] = useState(false)
    const [开始拖拽, 设置开始拖拽] = useState(false)
    const [拖拽起始坐标, 设置拖拽起始坐标] = useState()
    const [左侧宽度, 设置左侧宽度] = useState(390)
    // const [FifthTitle, setFifthTitle] = useState([]) // 五级标题
    // const [placeholder, setPlaceholder] = useState('多个关键词中间加空格')

    
    const law_map = useMemo(() => {
        const ma = new Map()
        const setData = (list) => {
            list.forEach((item) => {
                ma.set(item.id, item)
                if (item.children && item.children.length > 0)
                    setData(item.children)
            })
        }
        setData(law)
        return ma
    }, [law])

    //  正则匹配加粗字段
    function boldText(tripeData){
        const newTripe = tripeData.map((item)=>{
            // 如果item.content中已经包含了h4标签，就不再标签
            if(item.content.includes('<h4>')){
                return item
            }
            // 正则判断item.content是否包含对应的五级标
                const reg = new RegExp(`${item.title}\.*`)
                if(reg.test(item.content)){
                    // 将标题设置成h4元素
                    item.content = item.content.replace(reg, `<h4>${item.title}</h4>`);
                    // console.log(item.content);
                }
             return item
            })
        return newTripe
        }

    // 获取列表数据
    async function getLawList() {
        //TODO: 判断缓存是否更新
        const useCache=  await isUseCache()
        if (useCache){
          const data=  await  getLawsListFromCache()
          if (data) {
            setLaw(data)
            return
          }
        }
        const res = await user.mockGet(api.mokao_fatiaoV2,{})

        if (res && res?.status === 200) {
            // 请求成功，赋值
            // const data = res.data
            setLaw(res?.data)
            set_LAWS_LIST_V2(res?.data).then().catch((e)=>{
              console.log('缓存失败')
            })
            // setLawMapPi(data)
            return
        }
        console.warn('请求数据失败', res)
    }

    function domScrollIntoView(id, time = 0, count = 0) {
        setTimeout(() => {
          if (document.getElementById(id)){
            document.getElementById(id).scrollIntoView()
          }else{
            count <= 3 && domScrollIntoView(id, time + 100, count + 1)
          }
        }, time)
    }

    // 切换到对应的选项
    async function getLawItem(id, item_id) {
        const content = await getLawContentFromCache(id)
        if (content){
          // 请求成功，赋值
        //   setTripe(content)
          setTripe(boldText(content))
          domScrollIntoView(`${st['right']}_${item_id}`)
          return
        }

        setSelectId(item_id)
        let res = promise_map.get(id)
        function makeNewPromise() {
            setLoading(true)
            setTripe(null)
            const data = {
                promise: user.mockGet(api.fatiao_detailv2, { id }),
                time: Date.now()
            }
            promise_map.set(id, data)
            setPromiseMap(promise_map)
            return data
        }
        // 没有缓存
        if (!res) {
            res = makeNewPromise()
        }

        // 超过60s
        if (parseInt((Date.now() - res.time) / 1000) > 60) {
            res = makeNewPromise()
        }
        res = await res.promise
        setLoading(false)
        if (res?.status === 200) {
            // 请求成功，赋值
            // setTripe(res.data)
            setTripe(boldText(res.data))
          // 增加缓存
          try {
            set_LAWS_Content(id,res.data).catch((e)=>{
              console.error(e)
            })
          }catch (e){
            console.log(e)
          }
            domScrollIntoView(`${st['right']}_${item_id}`)
            return
        }
        console.warn('请求数据失败', res)
    }

    function searchItem(keyword) {
        const words = keyword.split(' ')
        const ma = []
        setSearchRes([])
        setSearchResIdx(0)
        words.map(itm => {
            const setData = (list) => {
                let count = 0
                list.forEach((item) => {
                    let ischongfu = false
                    ma.map(ite => {
                        if (ite.id == item.id) {
                            ischongfu = true
                        }
                    })
                    // 去掉文字间的空格
                    if (item.title.replace(/\s*/g, '').indexOf(itm) != -1 && !ischongfu) {
                        count++
                        ma.push(item)
                    }
                    if (item.children && item.children.length > 0) {
                        const children_count = setData(item.children)
                        if (children_count > 0) {
                            count += children_count
                            law_map.get(item.id) &&
                                (law_map.get(item.id)['is_open'] = true)
                        }
                    }
                })
                return count
            }
            setLaw([...law])
            setData(law)
        })
        for (let i = 0; i < ma.length; i++) {
            for (let j = i+1; j < ma.length; j++) {
                let a = ma[i]
                let b = ma[j]
                if (a.id > b.id) {
                    ma[i] = b
                    ma[j] = a
                }
            }
        }
        setSearchRes(ma)
        jump(ma, 0)
    }

    async function jump(search_res, idx) {
        if (!search_res || search_res.length < 1) return
        setSearchResIdx(idx)
        domScrollIntoView(`${st['list']}_${search_res[idx].id}`)
        if (search_res[idx].children && search_res[idx].children.length > 0) {
            await getLawItem(search_res[idx].id, search_res[idx].id)
            document.getElementById(st['right']).scrollTop = 0
        } else {
            await getLawItem(search_res[idx].parentId, search_res[idx].id)
        }
    }

    useEffect(() => {
        getLawList()
    }, [])

    function 鼠标移动(e) {
        设置左侧宽度(左侧宽度 + e.pageX - 拖拽起始坐标.x)
        e.stopPropagation()
    }

    function 鼠标松开(e) {
        设置开始拖拽(false)
        设置拖拽起始坐标(undefined)
        e.stopPropagation()
    }

    useEffect(() => {
        if (开始拖拽 && 拖拽起始坐标) {
            window.addEventListener('mousemove', 鼠标移动)
            window.addEventListener('mouseup', 鼠标松开)
        }
        return () => {
            window.removeEventListener('mousemove', 鼠标移动)
            window.removeEventListener('mouseup', 鼠标松开)
        }
    }, [开始拖拽, 拖拽起始坐标])

    return (
        <div
            {...props}
            className={cn(st['box'], { [st['quanping']]: is_quanping })}
        >
            <div className={cn(st['top'], 'drag-handle')} style={{cursor: closeFt ? 'move' : 'default'}}>
                <div className={st['l-title']} title="法律法规汇编">法律法规汇编</div>
                {closeFt && (
                    <img
                        src="https://oss.zhumavip.com/images/lawPage/ic-close.png"
                        onClick={() => {
                            closeFt(),
                            setRndObj({
                                width: 910,
                                height: 500,
                                x: (document.documentElement.clientWidth - 910) / 2,
                                y: (document.documentElement.clientHeight - 500) / 2,
                                全屏否: false
                            })
                        }}
                    />
                )}
                {!is_quanping && (
                    <img
                        src="https://oss.zhumavip.com/images/lawPage/ic-fangda.png"
                        onClick={() => {
                            setIsQuanping(!is_quanping)
                            onSize && onSize(!is_quanping)
                        }}
                    />
                )}
                {is_quanping && (
                    <img
                        src="https://oss.zhumavip.com/images/lawPage/ic-zuixiaohua.png"
                        onClick={() => {
                            setIsQuanping(!is_quanping)
                            onSize && onSize(!is_quanping)
                        }}
                    />
                )}
                {closeFt && (
                    <img
                        src={require('./images/suoxiao.png')}
                        onClick={() => {
                            setIsXiaoshi(true)
                        }}
                    />
                )}
            </div>
            <div className={st['bottom']}>
                {hide_left ? (
                    <div className={st['hide-left']}>
                        <div className={st['__navbar']}>
                            <Icon
                                name="youjiantou"
                                className={st['nav-open']}
                                onClick={() => setHideLeft(false)}
                            />
                        </div>
                    </div>
                ) : (
                    [
                        <div
                            key={1}
                            className={st['left']}
                            style={{
                                width: `${左侧宽度}px`
                            }}
                        >
                            <div className={st['__navbar']}>
                                <div>章节导航</div>
                                <Icon
                                    name="fanhui"
                                    className={st['nav-open']}
                                    onClick={() => setHideLeft(true)}
                                />
                            </div>
                            <div className={st['search-area']}>
                                <div className={st['input-box']}>
                                    <input
                                        type="text"
                                        value={keyword}
                                        // placeholder={placeholder}
                                        // onFocus={() => setPlaceholder('')}
                                        // onBlur={() => setPlaceholder('多个关键词中间加空格')}
                                        onChange={(e) =>
                                            setKeyWord(e.target.value)
                                        }
                                        onKeyUp={(e) => {
                                            if (e.key == 'Enter') {
                                                searchItem(keyword)
                                            }
                                        }}
                                    />
                                    <img
                                        src={SEARCH_ICON}
                                        onClick={() => {searchItem(keyword), setStyle(false)}}
                                    />
                                </div>
                                <div className={st['search-right']}>
                                    <div
                                        className={st['__left']}
                                        onClick={() => {
                                            jump(
                                                search_res,
                                                search_res_idx - 1 >= 0
                                                    ? search_res_idx - 1
                                                    : search_res.length - 1
                                            ),
                                            setStyle(false)
                                        }}
                                    >
                                        <Icon name="fanhui" />
                                    </div>
                                    <div
                                        className={st['__right']}
                                        onClick={() => {
                                            jump(
                                                search_res,
                                                search_res_idx + 1 >=
                                                    search_res.length
                                                    ? 0
                                                    : search_res_idx + 1
                                            ),
                                            setStyle(false)
                                        }}
                                    >
                                        <Icon name="youjiantou" />
                                    </div>
                                </div>
                            </div>
                            <List
                                className={cn(
                                    {[st['list-area']]: true},
                                    {[st['noscroll']]: style},
                                    {[st['margin']]: style}
                                )}
                                setStyle={setStyle}
                                onClick={() => setStyle(false)}
                                data={law}
                                selectId={select_id}
                                onFolderLeftClick={({ data }) => {
                                    law_map.get(data.id)['is_open'] =
                                        !law_map.get(data.id)['is_open']
                                    return setLaw([...law])
                                }}
                                onFolderRightClick={({ data }) => {
                                    setSelectId(data.id)
                                }}
                                onFolderRightDoubleClick={({ data }) => {
                                    if (law_map.get(data.id)) {
                                        law_map.get(data.id)['is_open'] =
                                            !law_map.get(data.id)['is_open']
                                        setLaw([...law])
                                    }
                                    getLawItem(data.id, data.id)
                                    document.getElementById(
                                        st['right']
                                    ).scrollTop = 0
                                }}
                                onFileClick={({ data }) => {
                                    // setFifthTitle(findFifthLayerById(law,data.parentId))
                                    getLawItem(data.parentId, data.id)
                                }}
                            />
                        </div>,
                        <div
                            key={2}
                            className={st['movebar']}
                            onMouseDown={(e) => {
                                设置开始拖拽(true)
                                设置拖拽起始坐标({
                                    x: e.pageX
                                })

                                e.stopPropagation()
                            }}
                        ></div>
                    ]
                )}
                <div className={cn(
                    {[st['right']]: true},
                    {[st['noscroll']]: !style},
                    {[st['margin']]: !style && tripe}
                )} id={st['right']} onClick={() => setStyle(true)}>
                    {tripe ? (
                        tripe.map((item, idx) => (
                            <div key={idx} id={`${st['right']}_${item.id}`} dangerouslySetInnerHTML={{ __html: item.content }} onClick={() => setSelectId(-1)}></div>
                        ))
                    ) : (
                        <div className={st['right-tripe']}>
                            {loading ? '加载中' : '法律法规汇编'}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
